import { CustomerResidentialStatus } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const residentialStatusMessages = defineMessages({
  companyProvided: {
    defaultMessage: 'Company-provided',
    description: 'residential status title',
  },
  familyOwned: {
    defaultMessage: 'Family-owned',
    description: 'residential status title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'residential status title',
  },
  owned: {
    defaultMessage: 'Owned',
    description: 'residential status title',
  },
  rented: {
    defaultMessage: 'Rented',
    description: 'residential status title',
  },
})

export function translateResidentialStatus(
  intl: IntlShape,
  status: CustomerResidentialStatus,
): string {
  switch (status) {
    case CustomerResidentialStatus.COMPANY_PROVIDED:
      return intl.formatMessage(residentialStatusMessages.companyProvided)
    case CustomerResidentialStatus.FAMILY_OWNED:
      return intl.formatMessage(residentialStatusMessages.familyOwned)
    case CustomerResidentialStatus.OTHER:
      return intl.formatMessage(residentialStatusMessages.other)
    case CustomerResidentialStatus.OWNED:
      return intl.formatMessage(residentialStatusMessages.owned)
    case CustomerResidentialStatus.RENTED:
      return intl.formatMessage(residentialStatusMessages.rented)
  }
}
